export default __webpack_public_path__ + "static/media/mobile-phone.393bc435.svg";